export * from './utils/isGlobalUser';
